import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.265 2.387h-1.33a2.08 2.08 0 0 0-3.88 0h-1.32A2.712 2.712 0 0 0 2.025 5.1v7.14a2.712 2.712 0 0 0 2.71 2.71h6.53a2.712 2.712 0 0 0 2.71-2.71V5.1a2.712 2.712 0 0 0-2.71-2.713Zm-5.14 1.5h.54a.755.755 0 0 0 .75-.75.58.58 0 0 1 1.16 0 .755.755 0 0 0 .75.75h.54v.49h-3.74Zm6.35 8.35a1.208 1.208 0 0 1-1.21 1.21h-6.53a1.208 1.208 0 0 1-1.21-1.21V5.1a1.2 1.2 0 0 1 1.1-1.2v1.23a.755.755 0 0 0 .75.75h5.24a.755.755 0 0 0 .75-.75V3.9a1.2 1.2 0 0 1 1.11 1.2Zm-3.05-2.59v1.5h-3.92v-1.5Zm1.31-2.4v1.5h-5.23v-1.5Z';
const draw24px =
  'M16.19,12.19h-8v-1.5h8Zm-2,2.16h-6v1.5h6ZM20.75,7V17.91A3.75,3.75,0,0,1,17,21.66H7a3.76,3.76,0,0,1-3.75-3.75V7A3.76,3.76,0,0,1,7,3.25h2.3a2.79,2.79,0,0,1,5.38,0H17A3.75,3.75,0,0,1,20.75,7Zm-12-2.25V6.29h6.5V4.75H14A.76.76,0,0,1,13.29,4a1.29,1.29,0,1,0-2.58,0,.75.75,0,0,1-.75.75ZM19.25,7A2.25,2.25,0,0,0,17,4.75h-.25V7a.75.75,0,0,1-.75.75H8A.75.75,0,0,1,7.25,7V4.75H7A2.25,2.25,0,0,0,4.76,7V17.91A2.25,2.25,0,0,0,7,20.16H17a2.25,2.25,0,0,0,2.25-2.25Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ClipboardIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'clipboard'),
) as IconWithRender;

ClipboardIcon.displayName = 'ClipboardIcon';
ClipboardIcon.propTypes = Icon.propTypes;
ClipboardIcon.renderIcon = (props) => <ClipboardIcon {...props} />;
export default ClipboardIcon;
